import React, { useEffect, useState } from 'react';
import InputText from './inputs/InputText';
import InputSelect from './inputs/InputSelect';
import styled from 'styled-components';
import { Modal, Box, Button } from '@material-ui/core';
import { Form } from 'informed';
import axios from 'axios';
import { API_HOST } from '../consts';
import { debounce } from 'lodash';
import { any } from 'prop-types';

const FilterRedacao = ({
  className,
  open,
  handleClose,
  search,
  onChange,
  filters,
  fetchWithSearch
}) => {
  const [firstTimeOpening, setFirstTimeOpening] = useState(true);
  const [optionsInput, setOptionsInput] = useState({
    tipo: [],
    genero: [],
    periodo: [],
    status: [
      { label: 'Novo', value: 1 },
      { label: 'Aplicado', value: 2 },
      { label: 'Inativo', value: 3 },
      { label: 'Em análise', value: 4 }
    ],
    pedido: [
      { label: 'Aguardando análise', value: 1 },
      { label: 'Aprovado', value: 2 },
      { label: 'Reprovado', value: 3 },
      { label: 'Agendado', value: 4 }
    ]
  });
  const [filterFields, setFilterFields] = useState({
    tipo: '',
    genero: '',
    periodo: '',
    status: '',
    pedido: ''
  });
  const [habilidade, setHabilidade] = useState('');

  useEffect(() => {
    // if (firstTimeOpening) {
    //   fetchPeriodo()
    //   setFirstTimeOpening(false)
    // }
    fetchPeriodo();
    fetchTipo();
  }, []);

  const fetchPeriodo = () => {
    axios
      .get(`${API_HOST}/core/periodo`, {})
      .then((response) => {
        const options = response.data.map((mapResponse) => ({
          value: mapResponse.id,
          label: mapResponse.descricao,
          codigo: mapResponse.nivel_id
        }));
        setOptionsInput((prevState) => ({ ...prevState, periodo: options }));
      })
      .catch((error) => console.log(error));
  };

  const fetchTipo = async () => {
    axios
      .get(`${API_HOST}/redacao_temas/tipos`)
      .then((response) => {
        const options = response.data.map((mapResponse) => ({
          value: mapResponse.id,
          label: mapResponse.nome
        }));
        setOptionsInput((prevState) => ({ ...prevState, tipo: options }));
      })
      .catch((error) => console.log(error));
  };

  const fetchGenero = (tipo) => {
    axios
      .get(`${API_HOST}/redacao_temas/generos`, {
        tipo
      })
      .then((response) => {
        const options = response.data.map((mapResponse) => ({
          value: mapResponse.id,
          label: mapResponse.nome
        }));
        setOptionsInput((prevState) => ({ ...prevState, genero: options }));
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    if (optionsInput.tipo) {
      fetchGenero(optionsInput.tipo);
    }
  }, [optionsInput.tipo]);

  const handleChangeFilter = (key, value) => {
    setFilterFields((prev) => {
      let copyArry = prev;
      copyArry[key] = value;
      return { ...copyArry };
    });
  };

  const handleSearch = async () => {
    await fetchWithSearch(filterFields);
    setFilterFields({
      tipo: '',
      genero: '',
      periodo: '',
      status: '',
      pedido: ''
    });
    handleClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      className={className}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <Box
        style={{
          minWidth: '1000px',
          background: '#fff',
          borderRadius: '5px'
        }}
      >
        <div className="title-div">
          <label> Buscar Atividades</label>
          <i onClick={handleClose} class="fa fa-times" aria-hidden="true"></i>
        </div>
        <Form>
          <h5 className="subtitles">Dados Gerais</h5>
          <div className="input-divs">
            <InputSelect
              label="Série/Ano"
              col="col-md-4"
              field="periodo"
              onChange={(e) => {
                handleChangeFilter('periodo', e ? e.value : '');
              }}
              options={optionsInput.periodo}
            />
            <InputSelect
              label="Tipo"
              col="col-md-4"
              field="tipo"
              onChange={(e) => {
                handleChangeFilter('tipo', e ? e.value : '');
              }}
              options={optionsInput.tipo}
            />
            <InputSelect
              label="Gênero"
              col="col-md-4"
              field="genero"
              onChange={(e) => {
                handleChangeFilter('genero', e ? e.value : '');
              }}
              options={optionsInput.genero}
            />
          </div>
          <div className="input-divs">
            <InputSelect
              label="Status do Tema"
              col="col-md-4"
              field="status"
              onChange={(e) => {
                handleChangeFilter('status', e ? e.value : '');
              }}
              options={optionsInput.status}
            />
            <InputSelect
              label="Status do Pedido"
              col="col-md-4"
              field="pedido"
              onChange={(e) => {
                handleChangeFilter('pedido_status', e ? e.value : '');
              }}
              options={optionsInput.pedido}
            />
          </div>
          <div
            className="buttons-div"
            style={{
              display: 'flex',
              justifyContent: 'center',
              margin: '10px'
            }}
          >
            <Button
              className="button-close"
              style={{
                marginTop: '10px',
                borderRadius: '70px',
                background: '#E4E4E4',
                boxShadow: '2px 2px 7px rgba(0, 0, 0, 0.25)',
                color: '#878787',
                padding: '5px 20px',
                marginRight: '26px'
              }}
              onClick={handleClose}
            >
              Fechar
            </Button>
            <Button
              className="button-search"
              onClick={() => handleSearch()}
              style={{
                marginTop: '10px',
                borderRadius: '70px',
                boxShadow: '2px 2px 7px rgba(0, 0, 0, 0.25)',
                padding: '5px 20px'
              }}
            >
              Buscar
            </Button>
          </div>
        </Form>
      </Box>
    </Modal>
  );
};

export default styled(FilterRedacao)`
  .title-div {
    display: flex;
    width: 100%;
    height: 3rem;
    justify-content: space-between;
    padding: 0rem 1rem;
    align-items: center;
    background-color: ${(props) => props.theme.primary};
    border-radius: 5px 5px 0px 0px;
    label {
      color: #fff;
      font-size: 20px;
      font-weight: 600;
      margin-top: 0.5rem;
    }
    i {
      color: #fff;
      font-size: 20px;
      cursor: pointer;
    }
  }

  .subtitles {
    background: #f7f7f7;
    padding-top: 10px;
    padding-bottom: 7px;
    color: ${(props) => props.theme.primary};
    padding-left: 15px;
  }

  .input-divs {
    display: flex;
    padding: 1rem;
    width: 100%;
  }

  .buttons-div {
    width: 100%;
    display: flex;
    align-items: end;
    justify-content: end;
    gap: 1rem;
    padding: 1rem;
  }

  .button-search {
    background: ${(props) => props.theme.primary};
    color: #fff;
    :hover {
      background: ${(props) => props.theme.secondary};
    }
    :focus {
      outline: none;
    }
  }

  .button-close {
    background: ${(props) => props.theme.danger};
    color: #fff;
    :hover {
      background: ${(props) => props.theme.danger};
    }
    :focus {
      outline: none;
    }
  }
`;
